import axiosInstance from "@/plugins/axios"

import { defineStore } from "pinia"

export const useShiftsStore = defineStore("shifts", {
  state: () => ({
    shifts: [],
    currentPage: null,
    loadMore: false,
    totalpages: null,
  }),
  getters: {
    loadMoreUrl(state) {
      return state.loadMore
    },
    currentPagess(state) {
      return state.currentPage
    },
    totalpage(state) {
      return state.totalpages
    },
  },
  actions: {
    async fetchShifts(pageNo,number) {
      try {
        const response = await axiosInstance.get(
          `/shifts-paginate/${number||10}/?${pageNo || 1}`
        )
        this.shifts = response.data.data.data
        this.currentPage = response.data.data.per_page
        this.totalpages = response.data.data.total
        this.currentPage = response.data.data.current_page
        this.totalpages = response.data.data.total

        if (response.data.data?.next_page_url) {
          this.loadMore = true
        } else {
          this.loadMore = false
        }
      } catch (error) {
        console.error("Error fetching shifts:", error)
      }
    },
    async postshift(formData) {
      try {
        const response = await axiosInstance.post("/shifts/", formData)
        return response.data // Return the response data if needed
      } catch (error) {
        console.error("Failed to post shift:", error)
        throw error // Rethrow the error to handle it in the calling code
      }
    },
    async pushshift(id,formData) {
      try {
        const response = await axiosInstance.put(`/shifts/${id}`, formData)
        return response.data // Return the response data if needed
      } catch (error) {
        console.error("Failed to post shift:", error)
        throw error // Rethrow the error to handle it in the calling code
      }
    },
    async deleteshift(id) {
      try {
        const response = await axiosInstance.delete(`/shifts/${id}`)
        return response.data // Return the response data if needed
      } catch (error) {
        console.error("Failed to post shift:", error)
        throw error // Rethrow the error to handle it in the calling code
      }
    },
  },
})
